export class AppError extends Error {
  readonly code: string;

  constructor(message: string, code: string = 'APP_ERROR') {
    super(message);
    this.name = 'AppError';
    this.code = code;
  }
}

export class HttpError extends AppError {
  readonly status: number;
  readonly errors?: Record<string, string[]>;

  constructor(message: string, status: number, errors?: Record<string, string[]>) {
    super(message, 'HTTP_ERROR');
    this.name = 'HttpError';
    this.status = status;
    this.errors = errors;
  }
}

export class ValidationError extends AppError {
  readonly errors: Record<string, string[]>;

  constructor(errors: Record<string, string[]>) {
    super('The given data was invalid.', 'VALIDATION_ERROR');
    this.name = 'ValidationError';
    this.errors = errors;
  }
}
